import { useState } from 'react';
import { useMutation } from '@apollo/client';
import { graphql } from '../../__generated__';

export const useDownloadDocument = () => {
  const [downloadedURL, setDownloadedURl] = useState<string>();

  const [getURL, { loading }] = useMutation(
    graphql(`
      mutation getDocumentURL($id: ID, $key: String) {
        getDocumentURL(id: $id, key: $key)
      }
    `),
  );

  const onPressDownload = async (
    documentKey: string | undefined,
    requestID: string | undefined,
  ) => {
    if (!documentKey || !requestID) return;

    const { data } = await getURL({
      variables: {
        key: documentKey,
        id: requestID,
      },
    });

    if (!data?.getDocumentURL) return;

    setDownloadedURl(data?.getDocumentURL);

    window.location.href = data?.getDocumentURL;
  };

  return {
    onPressDownload,
    downloadedURL,
    downloadingDocument: loading,
  };
};
